import React from 'react';
import { sendEvent } from 'shared/helpers/requests';
import styles from './FirstBlock.module.scss';
import { ReactComponent as LogoIcon } from '../../images/logo.svg';
import { ReactComponent as TitleIcon } from '../../images/title_icon.svg';
import { ReactComponent as StarIcon } from '../../images/star.svg';
import { BuyButton } from '../BuyButton';
import { EVENT_SOURCE, EVENT_TYPE, Price } from '../../constants';
import { useLocalStorage } from '../../hooks';

type Props = {
  price: Price;
  isSubjects: boolean;
  isCourses: boolean;
  isSubscription: boolean;
  onValidationOpen(): void;
  goToUchiMain(): void;
  goToThirdBlock(): void;
};

const TAGS = {
  default: [
    'Закрепить изученное',
    'Поддержать интерес ребенка',
    'Расширить кругозор',
    'Изучить новые темы',
  ],
  subjects: [
    'Закрепить изученное',
    'Поддержать интерес ребенка',
    'Понять сложное',
    'Догнать пропущенные темы',
  ],
};

export function FirstBlock({
  price,
  isSubjects,
  isCourses,
  isSubscription,
  onValidationOpen,
  goToUchiMain,
  goToThirdBlock,
}: Props) {
  const [seenSorry] = useLocalStorage('seenSorry', false);
  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <div className={styles.content}>
        <LogoIcon className={styles.logo} onClick={goToUchiMain} />
        <h1 className={styles.title}>
          Прямые эфиры <br />
          для начальной школы
          <TitleIcon />
        </h1>
        <p className={styles.description}>
          <span>Интерактивные </span>
          онлайн-занятия с&nbsp;преподавателем
          <span />
        </p>
        <div className={styles.tags}>
          {TAGS[isSubjects ? 'subjects' : 'default'].map((tag) => (
            <div key={tag} className={styles.tag}>
              <StarIcon />
              {tag}
            </div>
          ))}
        </div>
        {!seenSorry && (
          <>
            <BuyButton
              onClick={() => {
                sendEvent({
                  eventSource: isSubjects
                    ? EVENT_SOURCE.SHKOLA
                    : EVENT_SOURCE[isCourses ? 'COURSES' : 'PODPISKA'],
                  eventType:
                    EVENT_TYPE[isSubscription || isSubjects ? 'CLICK_BUY' : 'CLICK_CHOOSE'],
                  eventInfo: JSON.stringify({ place: 'above' }),
                });
                if (isCourses) {
                  goToThirdBlock();
                } else {
                  onValidationOpen();
                }
              }}
              text={isCourses ? 'Выбрать курс' : 'Оформить доступ'}
            />
            {/* TODO isSubjects=true цена должна быть другой */}
            {!isCourses && (
              <p className={styles.price}>{price.priceForLesson}&nbsp;₽&nbsp;/ занятие</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
